/* src/app/components/doc-viewer-new/access-denied/access-denied.component.scss */
.wrapper {
  min-height: 75vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
.wrapper-button {
  padding-left: 50px;
  padding-right: 60px;
}
/*# sourceMappingURL=access-denied.component.css.map */
